import React, { useState } from "react";
import styles from "./LoginForm.module.css";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../Api/Api";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import axios from "axios";
import logo from "../Images/logo.jpg";
import {
  TextField,
  Button,
  IconButton,
  InputAdornment,
  FormControl,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const LoginForm = () => {
  const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handlePasswordToggle = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    try {
      await loginAdmin(email, password);
      navigate("/dashboard");
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const { response } = error;
        console.error(
          "Login error:",
          response?.data?.message || "An error occurred"
        );
      }
    } finally {
      setUsername("");
      setPassword("");
      setLoading(false);
    }
  };

  // Styling for text fields
  const textFieldStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      borderRadius: "4px",
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#aaa",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#3f51b5",
      },
    },
    "& .MuiInputLabel-root": {
      color: "#666",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#3f51b5",
    },
  };

  return (
    <div className={styles.main}>
      {loading && <LoadingScreen />}
      <div className={styles.head}>
        <img src={logo} alt="logo" />
      </div>
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        <h1 className={styles.heading}>Admin Login</h1>

        <FormControl fullWidth margin="normal">
          <TextField
            label="Username"
            id="email"
            type="text"
            value={email}
            onChange={handleUsernameChange}
            variant="outlined"
            required
            sx={textFieldStyle}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <TextField
            label="Password"
            id="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            variant="outlined"
            required
            sx={textFieldStyle}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handlePasswordToggle}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          className={styles.loginButton}
          sx={{
            backgroundColor: "#3f51b5",
            "&:hover": {
              backgroundColor: "#303f9f",
            },
          }}
        >
          Login
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
